export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11805.e8e10a53.jpg";